import { Checkbox, InputAdornment, TextField } from "@material-ui/core";

interface TextFieldWithCheckboxProps {
	checkboxValue: boolean;
	className?: string;
	label?: string;
	disabled?: boolean;
	onCheckboxChange: (checked: boolean) => void;
	onFocus?: () => void;
	onBlur?: () => void;
}

export const TextFieldWithCheckbox = ({
	checkboxValue,
	label,
	className,
	disabled = false,
	onCheckboxChange,
	onFocus,
	onBlur,
}: TextFieldWithCheckboxProps) => {
	return (
		<div
			onClick={() => onCheckboxChange(!checkboxValue)}
			style={{ cursor: "pointer" }}
		>
			<TextField
				fullWidth
				variant="outlined"
				label={label}
				value=""
				disabled
				onFocus={onFocus}
				onBlur={onBlur}
				className={className}
				InputLabelProps={{
					style: {
						color: disabled ? "#a4a4a4" : "black",
						fontWeight: disabled ? 500 : 400,
					},
				}}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<Checkbox
								checked={checkboxValue}
								onChange={(e) => onCheckboxChange(e.target.checked)}
								color="primary"
								disabled={disabled}
								size="small"
								style={{ cursor: "pointer" }}
							/>
						</InputAdornment>
					),
				}}
			/>
		</div>
	);
};
